// Цвета синхронизированы с реальными темами экрана
// (web-app/src/components/screen/themes/classic.ts, diaDeMuertos.ts).
// background — доминирующий тон фона дня, accent — акцент (золото/бархатец),
// highlight — светлый текст поверх фона.
export const SCREEN_THEMES = [
    {
        id: 'classic',
        label: 'Обычная',
        description: 'Тёмно-бордовый нуар клуба',
        preview: {
            background: '#1A0A0E',
            accent: '#D9A441',
            highlight: '#EDE6DA',
        },
    },
    {
        id: 'dia_de_muertos',
        label: 'День мёртвых',
        description: 'Мексиканский праздник к Хеллоуину',
        preview: {
            background: '#4A1760',
            accent: '#F5A000',
            highlight: '#FF5B8A',
        },
    },
];
export const DEFAULT_SCREEN_THEME = 'classic';
export const getScreenThemeLabel = (theme) => { var _a, _b; return (_b = (_a = SCREEN_THEMES.find((t) => t.id === theme)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : theme; };
